export default {
  "ORDER_WAIT_SHIP": "পণ্য প্রেরণের জন্য অপেক্ষমান",
  "Men fashion": "পুরুষ ফ্যাশন",
  "MyAccount_MyProfile_label_First": "নাম",
  "MyAccount_MyShippingDetails_Phone": "টেলিফোন নম্বর",
  "Page_not_found_message1": "দুঃখিত, এই পৃষ্ঠাটি খুঁজে পাওয়া যায়নি",
  "Help": "সহায়তা",
  "Sign in": "সাইন ইন করুন",
  "Register": "নিবন্ধন করুন",
  "Category_sorting_Item": "সাজানো পণ্যের ধরণ নির্বাচন করুন",
  "cart_clear": "কার্ট খালি করুন",
  "Payment & Delivery": "পেমেন্ট এবং ডেলিভারি",
  "Send my feedback": "আমার প্রতিক্রিয়া প্রেরণ করুন",
  "MyAccount_MyProfile_Save": "পরিবর্তনগুলি সংরক্ষণ করুন",
  "Continue_billing": "বিলিং চালিয়ে যান",
  "Categories": "বিভাগসমূহ",
  "Read and understand": "আমি পড়ে বুঝেছি",
  "Feel free to edit": "আপনি যে কোনও বিস্তারিত সম্পাদনা করতে সম্মত হন, যাতে আপনার অ্যাকাউন্ট সর্বদা আধুনিক থাকে",
  "Select payment method": "পেমেন্ট মেথড নির্বাচন করুন",
  "Login_input_email": "আপনার ইমেল",
  "Login_input_first": "নাম",
  "Account": "অ্যাকাউন্ট",
  "Create_Time_Asc": "সিরিজেক্ট করুন",
  "concactus_label": "মতামত বা প্রশ্ন",
  "Order_Grade": "অর্ডার রেটিং",
  "wishlist_empty_desc": "এখনও আপনি কার্টে কোনও পণ্য যোগ করেন নি। শপিং শুরু করেন!",
  "cartpreviewShipping_messageinfo": "বিনিয়োগ প্রতিবেদন এবং আগম তারিখ পাওয়া সম্ভব হতে পারে",
  "unsubscribe": "আপনি নিজেকে অনসাবস্থা থেকে সম্পূর্ণ ফ্রি করতে পারেন",
  "prompt": "সাহায্যকারী",
  "MyAccount_MyProfile_yinsi_message": "Brand name - ইউজারের ব্যক্তিগত উপাত্ত সংরক্ষণ একটি গুরুত্বপূর্ণ বিষয়, এবং আমরা এর দিক দিয়ে গুরুত্ব বিশেষ দর্শাচ্ছ এবং ব্যবহারকারীদের ব্যক্তিগত উপাত্ত সংরক্ষণে নির্বাহে প্রতিশ্রুতিবদ্ধ। আরও জানতে ",
  "About us": "আমাদের সম্পর্কে",
  "or": "অথবা",
  "MyAccount_Order_History_All": "সমস্ত অর্ডার",
  "What_We_Improve": "আমরা কিভাবে উন্নয়ন করি?",
  "MyAccount_ShippingDetails_title": "প্রেরণ বিস্তারিত",
  "MyAccount_Order_History_Tabs2": "অপেক্ষমান অর্ডার",
  "Go_back_shopping": "কেনাকাটা চালিয়ে যান",
  "Product": "পণ্য",
  "Order summary": "অর্ডার সারাংশ",
  "payment_order_total": "টোটাল অর্ডার",
  "Departments": "বিভাগসমূহ",
  "Download": "ডাউনলোড করুন",
  "Your_Purchase_Order": "আপনার অর্ডার",
  "Your_Account": "আপনার অ্যাকাউন্ট",
  "order_after_sales_list_null": "আপনার পাশে কোনও অর্ডার নেই",
  "All_After_sales_orders": "সমস্ত অর্ডারের পরবর্তী দক্ষতা",
  "Filters": "ছাঁকনি",
  "search_results_not": "আমরা দেওয়া ফразের সাথে সংশ্লিষ্ট ফলাফল খুঁজে পাই নি",
  "ORDER_WAIT_RECEIPT": "অপেক্ষমান গ্রহণ",
  "ORDER_CLOSED": "বন্ধ হয়েছে",
  "Order_View_details": "বিস্তারিত দেখুন",
  "Subscribe_to_message": "প্রচারিত ও ক্রিয়াকলাপ যা আসছে তা জানতে। উপহার এবং বিশেষ প্রচেষ্টা পেতে!",
  "TaxFee": "কর ফি",
  "Apply": "প্রয়োগ করুন",
  "Total_price": "মোট দাম",
  "Description": "বিবরণসমূহ",
  "Payment method": "অর্থ প্রদানের পদ্ধতি",
  "Back": "পেছনে",
  "Empty": "দেখতে যেমন লাগে না যে আপনি কিছুই কার্টে যোগ করেন নি। এটি পূর্ণ করতে কেনাকাটা শুরু করুন।",
  "After_sales": "বিক্রয়ের পরে",
  "Instruction3": "হ্যাঁ আমরা জানি",
  "MyAccount_MyShippingDetails_Last": "নামের শেষ",
  "MyAccount_MyShippingDetails_City": "শহর",
  "payment_order_discount": "অর্ডার ডিসকাউন্ট",
  "MyAccount_Order": "অর্ডার বিস্তারিত",
  "ID_Name_Error": "আপনার আইডি নাম লিখুন",
  "Kidswear": "কিডসওয়্যার",
  "Share your look": "আপনার দেখান",
  "Pay_Order": "অর্ডার প্রদান করুন",
  "Reset_Password": "পাসওয়ার্ড রিসেট করুন",
  "MyAccount_MyProfile_label2_pass1": "বর্তমান পাসওয়ার্ড",
  "Create_Time_Desc": "তৈরি সময়ক্রমে ক্রমবর্ধমান",
  "Items": "আইটেম",
  "Login_Register": "এখন নিবন্ধন করুন",
  "Back to homepage": "হোমপেজে ফিরুন",
  "switch_CNY": "চাইনিজ যুয়ানে স্যুইচ করুন",
  "Successful placed order": "তুমি সফলভাবে অর্ডার প্লেস করেছ। তুমি আমাদের ডেলিভারি স্ট্যাটাস ফিচার ব্যবহার করে অর্ডার স্ট্যাটাস চেক করতে পারবে। তুমি অর্ডার নিশ্চয়তা ইমেল পেয়ে যেতে হবে যা অর্ডার বিস্তারিত এবং ট্র্যাকিং লিঙ্ক সহ থাকবে।",
  "MyAccount_MyProfile_yinsi_link": "গোপনীয়তা নীতি",
  "Order_Date": "অর্ডার তারিখ",
  "Allow order notifications": "অর্ডার বিজ্ঞপ্তি অনুমতি দিন",
  "MyAccount_MyProfile_Tab1": "প্রোফাইল",
  "MyAccount_ShippingDetails_changeTitle": "ঠিকানা পরিবর্তন করুন",
  "ID_Number": "আইডি নম্বর",
  "Order_after_sales_message": "বিস্তারিত এবং অর্ডার বিক্রয়ের পরে",
  "MyAccount_MyProfile_title2": "যদি আপনি আপনার অ্যাকাউন্ট অ্যাক্সেস পাসওয়ার্ড পরিবর্তন করতে চান তবে নিম্নোক্ত তথ্যগুলি লিখুন:",
  "Customer service": "গ্রাহক সেবা",
  "MyAccount_MyProfile_Update": "পাসওয়ার্ড আপডেট করুন",
  "choose_language": "ভাষা নির্বাচন করুন",
  "ORDER_REFUNDING": "টাকা ফেরতসমূহে",
  "MyAccount_MyProfile_title1": "নীচের যে কোনও বিস্তারিত তথ্য সম্পাদন করতে সবসময় প্রস্তুত থাকুন যাতে আপনার অ্যাকাউন্টটি সর্বদা আধুনিক থাকে।",
  "ORDER_WAIT_RATE": "মুল্যায়ন করতে অপেক্ষমান",
  "after_sales_refund_order": "অর্ডার রিফান্ড",
  "Who we are": "আমরা কে",
  "Women fashion": "মহিলাদের ফ্যাশন",
  "Personal details": "ব্যক্তিগত বিবরণ",
  "Password": "পাসওয়ার্ড",
  "wishlist_empty_title": "আপনার শপিং ব্যাগ খালি",
  "Repeat_Password": "পাসওয়ার্ড পুনরাবৃত্তি করুন",
  "cart_price": "মোট দাম",
  "Sort_by": "সাজানোর দ্বারা",
  "Customer Reviews": "কাস্টমার রিভিউস",
  "Continue to shipping": "শিপিং চালিয়ে যান",
  "payment_make_order": "অর্ডার করুন",
  "save_order_review": "সম্পূর্ণ পর্যালোচনা দাখিল করুন",
  "Save_Password": "পাসওয়ার্ড সংরক্ষণ করুন",
  "cart_empty_title": "আপনার শপিং কার্ট খালি",
  "TopBar_help": "সহায়তা এবং প্রচলিত প্রশ্নের উত্তর",
  "colseCookie": "আমি জানি",
  "Password_Changed": "পাসওয়ার্ডটি সফলভাবে পরিবর্তন হয়েছে। আপনি এখন হোমপেজে ফেরত যেতে এবং লগইন করতে পারেন।",
  "Forgot Password Modal Email": "লগইন করার জন্য আপনার ইমেইল:",
  "MyAccount_Personal": "ব্যক্তিগত বিবরণ",
  "cartPreviewShipping": "সহজ শিপিং",
  "ORDER_AFTER_SALE": "সেল এফ্টার অর্ডারটি প্রস্তুত হচ্ছে",
  "Page_not_found": "পৃষ্ঠাটি খুঁজে পাওয়া যায়নি",
  "Find out more": "আরও জানতে",
  "Log into your account": "আপনার অ্যাকাউন্টে লগইন করুন",
  "Details_and_status_orders": "অনলাইন দোকানে অর্ডারের বিস্তারিত এবং অবস্থা পরীক্ষা করুন। আপনি সমস্ত অর্ডার বাতিল করতে এবং ফেরত দাবী করতে পারেন।",
  "Order_to_be_paid_message": "পেমেন্ট করা জন্য আদেশ",
  "Guarantee": "গ্যারান্টি",
  "Sections that interest you": "আপনি উত্সাহিত বিভাগ",
  "payment_post_tax": "ট্যাক্স পরিশোধ",
  "ORDER_PAID": "পেমেন্ট করা হয়েছে",
  "concactus_label5": "নামকরণ",
  "Item": "আইটেম",
  "Go_back": "ফিরে যান",
  "more": "আরও",
  "MyAccount": "আমার অ্যাকাউন্ট",
  "payment_agree_1": "আমি একমত",
  "total_items": "মোট আইটেম",
  "shopping_go": "পরিচালনা ডেলিভারির ঠিকানা",
  "ID_Type": "আইডি টাইপ",
  "after_sales_status": "বিক্রয়ের পূর্ববর্তী অবস্থা",
  "After_sales_apply": "বিক্রয়ের আবেদন করুন",
  "Login": "লগইন",
  "Quantity": "পরিমাণ",
  "payment_post_fee": "পোস্টে ফি",
  "MyAccount_Log_out": "লগ আউট",
  "Subtotal": "মোট দাম",
  "forgotPasswordConfirmation": "ধন্যবাদ! আপনি {0} ইমেল ব্যবহার করে হিসাব নিবন্ধন করেছেন তাহলে পাসওয়ার্ড রিসেট লিংকটি যথাযথ ফোল্ডারে পাবেন।",
  "MyAccount_Order_History_Tabs1": "আমার আদেশ ইতিহাস",
  "concactus_img": "ছবি আপলোড করুন",
  "Done": "সম্পন্ন",
  "Info after order": "আপনি আপনার অ্যাকাউন্টে ডিফাইন করা ইমেল এবং পাসওয়ার্ড ব্যবহার করে লগইন করতে পারেন। আপনার অ্যাকাউন্টে, আপনি ব্যক্তিগত তথ্য সম্পাদনা করতে পারেন, লেনদেনের ইতিহাস দেখতে পারেন, সাবস্ক্রিপশন সম্পাদনা করতে পারেন এবং অন্যান্য কিছু কাজ করতে পারেন।",
  "MyAccoubnt_Set_newsletter": "আপনার সংবাদ পত্রটি সেট করুন, আমরা আপনাকে নির্বাচন করা কিছু নতুন উৎপাদন এবং ট্রেন্ডি তথ্যের সাথে সপ্তাহান্ত আপনাকে পাঠিয়ে দিব।",
  "Shipping_method": "গ্রহণের পদ্ধতি",
  "after_sales_refund": "টাকা ফেরত",
  "After_sales_save": "পণ্য ফেরতের তথ্য সংরক্ষণ করুন",
  "go_order_history": "অর্ডার ইতিহাস দেখুন",
  "contactus_message_placeholder": "আপনার মন্তব্য বা প্রশ্ন এখানে লিখুন",
  "Login_Forgot_Password": "পাসওয়ার্ড মনে না রাখলে আপনি নতুন পাসওয়ার্ড সেট করতে পারেন।",
  "show_more": "আরও দেখুন",
  "MyAccount_MyProfile_label_email": "আপনার ইমেল",
  "MyAccount_MyProfile_label2_pass3": "পুনরাবৃত্তি পাসওয়ার্ড",
  "Products": "পণ্য",
  "Review": "পর্যালোচনা",
  "MyAccount_MyProfile_title3": "আপনার বর্তমান ইমেল ঠিকানা হলো",
  "Category_found_Products": "পাওয়া পণ্যগুলি",
  "Match": "ম্যাচ",
  "Read_all_reviews": "সমস্ত পর্যালোচনা পড়ুন",
  "Commercial information": "এবং ব্র্যান্ডের ব্যক্তিগতযুক্ত বাণিজ্যিক তথ্য ইমেলের মাধ্যমে স্বীকার করার জন্য একমত হন",
  "Change password your account": "আপনি যদি একাউন্টে পাসওয়ার্ড পরিবর্তন করতে চান, তবে নিচের নির্দেশনাগুলিটি অনুসরণ করুন",
  "ID_Name": "আইডি নাম",
  "All": "সব",
  "Instruction2": "কেবলমাত্র রক্ষণাবেক্ষণ নিয়ে মাত্র প্রয়োজনীয়?",
  "MyAccount_ShippingDetails_Add": "নতুন ঠিকানা যুক্ত করুন",
  "MyAccount_MyShippingDetails_Zip": "জিপ কোড",
  "go_pay_order": "পেমেন্ট করুন",
  "Thank_You_Inbox": "মেসেজ ইনবক্সে এসে না হলে অন্য একটি ইমেল ঠিকানা ব্যবহার করা চেষ্টা করুন যা আপনি যেখানে রেজিস্টার করেছেন সেটি।",
  "Subscribe": "সাবস্ক্রাইব",
  "confirm_subscription": "আমি সাবস্ক্রাইব কিনা পুষ্টি করি",
  "Login_input_Remember": "মনে রাখবেন",
  "Add to compare": "তুলনাত্মক তালিকায় যোগ করুন",
  "Brand": "ব্র্যান্ড",
  "Start_shopping": "শপিং শুরু করুন",
  "Select shipping method": "গ্রহণের পদ্ধতি নির্বাচন করুন",
  "address CN": "ঠিকানা চীনে, বর্তমান মুদ্রা হতে হবে রেনমিনবি",
  "MyAccount_MyShippingDetails_State": "রাজ্য / প্রদেশ",
  "Page_not_found_message2": "দয়া করে ফিরুন বা পুনরায় চেষ্টা করুন",
  "Go_to_checkout": "চেকআউটে যান",
  "See all results": "সমস্ত ফলাফল দেখুন",
  "search_results_inputnull": "আপনি এখনও কোনও পণ্য খুজে পাচ্ছেন না।",
  "subscribeToNewsletterModalContent": "সাবস্ক্রাইব করার পরে, আপনি ভিএসএফ থেকে বিশেষ অফার এবং তথ্য ইমেলের মাধ্যমে পেবেন। আমরা কোনও সময়েই আপনার ইমেলটি কোনও তৃতীয় পক্ষকে বিক্রি বা বিতরণ করব না। আমাদের দেখুন {0}।",
  "Download all": "সমস্ত ডাউনলোড করুন",
  "Login_input_last": "নামের শেষাংশ",
  "Amount": "পরিমাণ",
  "ORDER_WAIT_PAYMENT": "অপেক্ষারত",
  "Order_After_sales": "অর্ডারের পরে বিক্রির পরে",
  "concattus_button": "জমা দিন",
  "Shipping_valid_required": "এই আইটেমটি প্রয়োজনীয়",
  "Price": "মূল্য",
  "ID_Type_Error": "আপনার আইডি টাইপ নির্বাচন করুন",
  "Order_Status": "অর্ডার স্ট্যাটাস",
  "Payment methods": "পেমেন্ট পদ্ধতি",
  "MyAccount_MyProfile_Tab2": "পাসওয়ার্ড পরিবর্তন করুন",
  "Show on page": "পৃষ্ঠায় দেখান",
  "Edit": "সম্পাদনা করুন",
  "Change": "পরিবর্তন করুন",
  "MyAccount_ShippingDetails_Update": "ঠিকানা আপডেট করুন",
  "View": "দেখা হয়েছে",
  "Privacy": "গোপনীয়তা",
  "Enter_promo_code": "প্রোমো কোড প্রবেশ করুন",
  "Discount": "ডিসকাউন্ট",
  "Delete": "মুছে ফেলুন",
  "Wishlist": "ইচ্ছেতালিকা",
  "MyAccount_Order_History_Tabs3": "মোটামুটি ফিরে যান",
  "Go_To_Order_review": "অর্ডার পর্যবেক্ষণে যান",
  "Update personal data": "ব্যক্তিগত তথ্য আপডেট করুন",
  "payment_agree_2": "শর্তাদি এবং শর্ত",
  "or fill the details below": "বা নীচের বিশদগুলি পূরণ করুন",
  "Contact details updated": "আপনার ঠিকানা এবং যোগাযোগের বিবরণ নবায়ন করুন।",
  "Login_Create": "একটি অ্যাকাউন্ট তৈরি করুন",
  "Payment": "পারিশ্রমিক",
  "Billing": "বিলিং",
  "payment_insurance_tax": "বীমা ট্যাক্স",
  "Size guide": "আকার নির্দেশিকা",
  "Login_forgotten_password": "পাসওয়ার্ড ভুলেগেছেন?",
  "Login_no_account": "এখনও কোনও অ্যাকাউন্ট নেই?",
  "Privacy_Policy": "গোপনীয়তা নীতি",
  "BootomCookieTitle": "কুকি অনুমতি",
  "Use your personal data": "Brand name, আমরা ব্যক্তিগত উপাত্তের বিষয়টি খুবই গুরুত্বপূর্ণ বিষয়টি ধারণা করে এবং আমরা আমাদের ব্যবহারকারীদের ব্যক্তিগত উপাত্তি রক্ষার জন্য পরিশ্রম করছি। আরও বিস্তারিত জানতে জন্য আমাদেরকে দেখুন এবং আপনার ব্যক্তিগত তথ্য কিভাবে খেয়াল করছি সেই সম্পর্কে ধার",
  "Review my order": "আমার অর্ডার পর্যবেক্ষণ",
  "BootomCookieLink": "বিস্তারিত জানতে",
  "hide": "লুকান",
  "MyAccount_ShippingDetails_message_title": "আপনি চাইলে সমস্ত পরিবহন ঠিকানা পরিচালনা করতে পারেন (কাজস্থল, বাড়ির ঠিকানা ইত্যাদি), যাতে আপনাকে প্রতিটি অর্ডারে পরিবহন ঠিকানা স্বয়ংক্রিয়ভাবে প্রবেশ করতে হয় না।",
  "Purchase terms": "ক্রয়কৃত নিয়ম",
  "Billing_address": "বিলিং ঠিকানা",
  "Manage shipping addresses": "সমস্ত পরিবহনের ঠিকানা (কার্যস্থল, বাড়ির ঠিকানা ইত্যাদি) পরিচালনা করুন। এইভাবে আপনাকে প্রতিটি অর্ডারে স্বয়ংক্রিয়ভাবে পরিবহনের ঠিকানা প্রবেশ করতে হবে না।",
  "login_logbtn": "একাউন্টে লগইন করুন",
  "choose_currency": "মুদ্রা পছন্দ করুন",
  "ORDER_REFUNDED": "ক্রয় পরিত্যাগ করা হয়েছে",
  "After_sales_form": "বিক্রির পরে ফর্ম পূরন করুন",
  "add_To_Wishlist": "তালিকায় যোগ করুন",
  "search_results_inputnull2": "এখন শুরু করুন, আমরা আপনাকে সাহায্য করব।",
  "Total": "মোট",
  "Subscribe_to_newsletter": "সংবাদপত্রে সাবস্ক্রাইব করুন",
  "Shipping_valid_Phone": "দয়া করে একটি বৈধ ফোন নম্বর লিখুন",
  "concactus_label3": "শিরোনাম",
  "Manage billing addresses": "আপনি সমস্ত বিলিং ঠিকানা (কার্যস্থল, বাড়ির ঠিকানা...) পরিচালনা করতে পারেন যাতে আপনাকে প্রতিটি অর্ডারে হাতেলে বিলিং ঠিকানা লিখতে হবে না।",
  "Search_results_title": "অনুসন্ধানের ফলাফল",
  "payment_order_payment": "অর্ডার পেমেন্ট",
  "after_sales_Id": "বিক্রি পরে আইডি",
  "cart_title": "আমার কার্ট",
  "Order_Detail": "অর্ডারের বিস্তারিত",
  "concactus_label2": "দোকানের লিংক",
  "Shipping_valid_length_min": "এই ফিল্ডটি অন্তত {min} টি অক্ষর থাকা উচিত",
  "Product suggestions": "পণ্য পরামর্শ",
  "Return_home": "হোমে ফিরুন",
  "Quality in the details": "বিস্তারিতে মান দেওয়া",
  "Continue_to_payment": "পরিশোধ চালিয়ে যান",
  "Feedback": "আপনার প্রতিক্রিয়া আমাদের জন্য গুরুত্বপূর্ণ। আপনি আমাদের বর্ণনা করতে পারেন আমরা কি উন্নয়ন করতে পারি।",
  "Go back to shop": "দোকানে ফিরে যান",
  "Back_to_home": "হোমে ফিরুন",
  "Review_Content": "পর্যালোচনার বিষয়বস্তু",
  "add_To_Cart": "কার্টে যোগ করুন",
  "Read_reviews": "পর্যালোচনা পড়ুন",
  "Instruction1": "মেরামতের উপায়",
  "Email_address": "ইমেল ঠিকানা",
  "Category_Item_List": "তালিকা দেখুন",
  "Same as shipping address": "ডেলিভারি ঠিকানার সাথে একই",
  "Category_Item_Grid": "গ্রিড দেখুন",
  "ID_Number_Error": "আপনার পরিচয়পত্র নম্বরটি লিখুন",
  "concactus_label4": "যোগাযোগের ইমেল",
  "Additional_info": "অতিরিক্ত তথ্য",
  "add_shipping": "নতুন শিপিং ঠিকানা যোগ করুন",
  "Product_description": "Karissa V-Neck Tee হাফ ফিট ডিজাইন আছে এবং সব ধরনের শরীরের মধ্যে প্রয়োজন অংশগুলি প্রদর্শন করে। এটি মোড় নিয়ে যান, সাধারণ সমস্যাগুলি শুরু করে এবং জিমে আপনাকে আত্মবিশ্বাসে নির্ভর করে দেয়। ভালোবাসা পুরুষদের ককটেল ড্রেস এবং পার্টি পোশাকও আছে।",
  "Login_create_account": "আমার একটি অ্যাকাউন্ট তৈরি করুন",
  "after_sales_Reason": "বিক্রি পরে কারণ",
  "MyAccount_MyProfile_label_Last": "শ্রেণী",
  "MyAccount_MyProfile_label2_pass2": "নতুন পাসওয়ার্ড",
  "Save": "সংরক্ষণ করুন",
  "CartSliderTextBtn": "সেভ করুন পরে ক্রয় করতে",
  "Color": "রঙ",
  "Shipping_Tax": "ট্যাক্স শিপিং",
  "Subscribe_to_success": "সাবস্ক্রাইব করার জন্য আপনি অনুমোদিত",
  "Enjoy your free account": "আপনার বিনামূল্যে অ্যাকাউন্ট প্রয়োজনবোধ করুন!",
  "cart_empty_desc": "এটি এখনও লক্ষ্য করা হয়নি যে আপনি কিছুই কার্টে যোগ করেন নি। এখনই শপিং শুরু করুন এবং এটি পূর্ণ করুন।",
  "MyAccount_ShippingDetails_message_title2": "আপনার ঠিকানা এবং যোগাযোগের বিবরণ আপডেট রাখুন।",
  "An_error_occured": "একটি ত্রুটি ঘটেছে",
  "Country": "দেশ",
  "MyAccount_MyShippingDetails_First": "নাম",
  "payment_insurance_fee": "বীমা বৎসর ফি",
  "Home": "হোম",
  "Contact_us": "যোগাযোগ করুন আমাদের সাথে",
  "Cookies Policy": "কুকি নীতি",
  "Clear all": "সব মুছুন",
  "Basket": "বাস্কেট",
  "MyAccount_MyProfile_reqeatPassErrMsg": "নতুন পাসওয়ার্ড মিলছে না",
  "Your current email address is": "আপনার বর্তমান ইমেল ঠিকানা",
  "You currently have no orders": "আপনার কোন অর্ডার নেই",
  "Login_input_password": "পাসওয়ার্ড",
  "Promo_code": "প্রোমো কোড",
  "order_count": "অর্ডার সংখ্যা",
  "email_geshi_error": "বৈধ ইমেল ঠিকানা লিখুন",
  "your_email": "আপনার ইমেল",
  "email": "ইমেল",
  "you_have_subscribed": "আপনি সাবস্ক্রাইব করেছেন",
  "cancel_Subscribe": "সাবস্ক্রাইব বাতিল করুন",
  "save_and_pay": "সেভ এবং পেমেন্ট করুন",
  "hasInsurance": "কি আপনি বীমা কিনতে চান",
  "pleasePayType": "পেমেন্ট ধরণ নির্বাচন করুন",
  "zhuanfa_toBePay": "আপনার বন্ধুকে পেমেন্ট করতে পারেন",
  "linkCopied": "লিঙ্কটি কপি করা হয়েছে, এখন আপনি এটি শেয়ার করতে পারেন",
  "Links": "লিংক",
  "article_category": "প্রবন্ধ বিভাগ",
  "wechat_code_login_message": "দয়া করে ওয়েচ্যাট স্ক্যান করে লগইন করুন",
  "wechat_code_login": "ওয়েচ্যাট স্ক্যান করে লগইন করুন",
  "Api_Update_success": "হালনাগাদ সফল",
  "Please_Use_WeChat_login": "দয়া করে ওয়েচ্যাট লগইন ব্যবহার করুন",
  "mobile_geshi_error": "বৈধ মোবাইল নম্বর লিখুন",
  "Login_input_email_required": "ইমেইল লিখুন",
  "article_null": "লেখার নাই",
  "Login_with_microsoft": "মাইক্রোসফট লগইন",
  "article_null_des": "আপনি অন্যান্য বিভাগের নিবন্ধসমূহ পর্যবেক্ষণ করতে পারেন",
  "register_email": "ইমেইল রেজিস্ট্রেশন",
  "Login_tab_email": "ইমেল লগইন",
  "code.time": "{time} দ্বারা পুনঃচেষ্টা করা হবে",
  "Login_with_wechat": "WeChat লগইন",
  "cat_items_null_des": "আপনি অন্যান্য বিভাগের মধ্যে পণ্য দেখতে পারেন",
  "Login_with_facebook": "ফেসবুক লগইন",
  "Login_input_code": "ভেরিফিকেশন কোড",
  "Login_input_mobile_required": "মোবাইল নম্বর লিখুন",
  "Login_input_mobile": "আপনার মোবাইল নম্বর",
  "cat_items_null": "এই বিভাগে কোনও পণ্য নেই",
  "Login_with_twitter": "টুইটার লগইন",
  "mobile_code": "ভেরিফিকেশন কোড",
  "register_mobile": "মোবাইল রেজিস্ট্রেশন",
  "Login_tab_mobile": "মোবাইল লগইন",
  "Login_with_google": "Google লগইন",
  "OrderSku": "পণ্যের স্পেসিফিকেশন",
  "Order_logisticsNo": "পণ্যের লজিস্টিক্স কোড",
  "order_shopping_firstname": "নাম",
  "Order_logisticsName": "লজিস্টিক্স কোম্পানি",
  "ItemPrice": "পণ্যের দাম",
  "inPayOrderAll": "অপেক্ষমান পেমেন্ট তালিকা",
  "payPrice": "পেমেন্টের মূল্য",
  "shipping_add_success": "পরিষেবা ঠিকানা সফলভাবে তৈরি করা হয়েছে",
  "match_goods": "জনপ্রিয় পণ্য",
  "pay_code_refresh": "পেমেন্ট কোড রিফ্রেশ করুন",
  "pay_code_shixiao": "পেমেন্ট কোড অবৈধ হয়ে গেছে",
  "concactus_title": "আমাদের সাথে যোগাযোগ করুন",
  "Search_items": "অনুসন্ধান",
  "WebAutoLang": "আপনার ব্রাউজার পরামর্শ করা ভাষা হল: {lang}। আপনি কি এই ভাষায় পরিবর্তন করতে চান?",
  "Services_Name": "সেবা নাম",
  "Services_Price": "সেবা খরচ",
  "SwichLang": "ভাষা পরিবর্তন করুন",
  "Services_Description": "সেবা বর্ণনা",
  "goodinfo_null": "কোন পণ্য নেই",
  "goodinfo_null_des": "আপনি অন্যান্য বিভাগের পণ্য দেখতে পারেন",
  "notYetUseCode": "উপভোগ কোডটি এখনো ব্যবহৃত হয়নি",
  "guest_Login": "অতিথি লগইন",
  "billing_and_shipping": "বিলিং এবং শিপিং ঠিকানা সমান",
  "select_coupon": "কুপন নির্বাচন করুন",
  "select_gift": "উপহার নির্বাচন করুন",
  "currentUseCode": "বর্তমানে ব্যবহৃত কোড",
  "shipping_refresh": "তালিকা পুনরায় লোড করুন",
  "Shipping_details": "পণ্য গ্রহণের ঠিকানা",
  "MyAccount_Newsletter": "সাবস্ক্রাইব",
  "MyAccount_Profile": "প্রোফাইল",
  "MyAccount_Wishlist": "কামনা তালিকা",
  "See_all": "সমস্ত",
  "MyAccount_History": "অর্ডার রেকর্ড",
  "bind_microsoft": "মাইক্রোসফট বাঁধান",
  "bind_twitter": "টুইটার সংযোগ করুন",
  "bind_facebook": "ফেসবুক সংযুক্ত করো",
  "bind_wechat_code": "ওয়েচ্যাটের কোড",
  "bind_wechat": "ওয়েচ্যাট বাঁধান",
  "bind_google": "গুগল সংযোগ করুন",
  "Wishlist_Empty": "কোন ইচ্ছা তালিকা নেই",
  "discount_post_fee": "পোস্ট ফি ছাড়",
  "ORDER_PART_PAID": "আংশিক পেমেন্ট",
  "claimCouponeSuccess": "{name} কুপন পাওয়া সফল",
  "discount_kou": "{discount}ভাগ",
  "claimCoupone": "উত্তপ্তি করে নিন",
  "cartPreviewSafety_messageinfo": "আপনার ঠিকানায় নিরাপদভাবে এবং দ্রুত পাঠান হালকা করা হবে",
  "Order_No": "অর্ডার নম্বর",
  "cartPreviewSafety": "সুরক্ষিত ডেলিভারি",
  "Shipping": "পরিবহন",
  "MyAccount_MyShippingDetails_Street": "রাস্তা",
  "MyAccount_MyShippingDetails_HouseNumber": "বাড়ির নম্বর",
  "Shipping_title": "গ্রাহক ঠিকানা",
  "Offline_payment": "অফলাইন পেমেন্ট",
  "shopName": "দোকানের নাম",
  "Social": "সামাজিক",
  "SERVICE": "সেবা",
  "onlineContact": "অনলাইন যোগাযোগ",
  "confirm": "অনুমোদিত",
  "closeOrder": "অদক্ষতা আদেশ",
  "closeOrderContext": "আপনি কি আদেশটি বাতিল করতে নিশ্চিত হন?",
  "Message_Read": "পঠিত",
  "close.order.success": "অর্ডার সফলভাবে বাতিল হয়েছে",
  "shippingAddress": "বিস্তারিত ঠিকানা",
  "Message": "বার্তা",
  "Message_Empty_Title": "আপনার বার্তা খালি",
  "MyAccount_Message": "বার্তা",
  "Message_Empty": "কোন বার্তা নেই",
  "payment_order_note": "অর্ডার মন্তব্য",
  "go_to_see_prepid": "অপরিশোধিত অর্ডার দেখতে এখানে ক্লিক করুন",
  "operate": "অপারেট",
  "removeCartItemContext": "আপনি কি {title} অপসারণ করতে চান?",
  "shippingItemQty": "প্রেরণের পরিমাণ",
  "removeCartItem": "মহাকর্তা সরান",
  "shippingInfo": "প্রেরণের তথ্য",
  "Distributor_success": "প্রতিনিধি হিসাবে সফলভাবে যোগদান হয়েছে",
  "Distributor_apply": "প্রতিনিধি হিসাবে আবেদন করুন",
  "Distributor_Details": "প্রতিনিধি",
  "DistributorSataus": "অবস্থা",
  "Distributor_Details_Empty": "কোনও প্রতিনিধি নেই",
  "distributor.status.4": "বাতিল হয়েছে",
  "distributor.status.1": "পর্যালোচনার জন্য দাখিল করা হয়নি",
  "Distributor_copy_url": "প্রতিনিধি লিংক কপি করুন",
  "Order_Time": "অর্ডারের সময়",
  "Order_User": "অর্ডার দাতা",
  "Distributor_copy_success": "কপি সফল হয়েছে",
  "distributor.status.3": "লেনদেন হয়েছে",
  "MyAccount_Distributor": "প্রতিনিধি",
  "MyAccoubnt_Set_Distributor": "প্রতিনিধি হিসাবে আবেদন করুন",
  "distributor.status.2": "লেনদেন জন্য অপেক্ষারত",
  "DistributorAmount": "কমিশন",
  "Distributor_shenheshibai": "পরিবহন বিক্রেতা পরীক্ষামূলকভাবে নাকচ হয়নি",
  "Distributor_shenhezhong": "পরিবহন বিক্রেতা পরীক্ষামূলকভাবে চলমান",
  "Distributor_Order_Empty": "কোন পরিবহন আদেশ নেই",
  "NE": "নাইজার",
  "DJ": "জিবুতি",
  "KP": "উত্তর কোরিয়া",
  "US": "মার্কিন যুক্তরাষ্ট্র",
  "LC": "সেন্ট লুসিয়া",
  "NL": "নেদারল্যান্ডস",
  "CD": "ডমিনিকান প্রজাতন্ত্র",
  "IS": "আইসল্যান্ড",
  "MA": "মরক্কো",
  "GH": "ঘানা",
  "KR": "দক্ষিণ কোরিয়া",
  "MK": "ম্যাসেডোনিয়া",
  "HT": "হাইতি",
  "PF": "ফরাসি পলিনেশিয়া",
  "GA": "গাবন",
  "TD": "চাদ",
  "LB": "লেবানন",
  "CG": "কঙ্গো",
  "KG": "কিরগিজস্তান",
  "TA": "ট্রিস্টান-দা-কুনহা",
  "KW": "কুয়েত",
  "TL": "পূর্ব তিমুর",
  "IN": "ভারত",
  "NO": "নরওয়ে",
  "NG": "নাইজেরিয়া",
  "AQ": "দক্ষিণ শিমুলপারি",
  "LY": "লিবিয়া",
  "NI": "নিকারাগুয়া",
  "TT": "ত্রিনিদাদ ও টোব্যাগো",
  "HM": "হার্ড এবং ম্যাকডোনাল্ড দ্বীপপুঞ্জ",
  "PY": "প্যারাগুয়ে",
  "BA": "বসনিয়া ও হার্জেগোভিনা",
  "JP": "জাপান",
  "MD": "মলদোভা",
  "MT": "মল্টা",
  "RE": "রিইউনিয়ন দ্বীপ",
  "UG": "উগান্ডা",
  "SB": "সলোমন দ্বীপপুঞ্জ",
  "SL": "সিয়েরা লিওন",
  "CV": "কেইপ ভার্দ",
  "SD": "সুদান",
  "FO": "ফারো দ্বীপপুঞ্জ",
  "ZA": "দক্ষিণ আফ্রিকা",
  "TR": "তুরস্ক",
  "FK": "ফকল্যান্ড দ্বীপপুঞ্জ",
  "PA": "পানামা",
  "GF": "ফরাসি গয়ানা",
  "TJ": "তাজিকিস্তান",
  "NC": "নিউ ক্যালেডোনিয়া",
  "PM": "সেন্ট পিয়ের এবং মিকুলন দ্বীপপুঞ্জ",
  "NU": "নিউই",
  "AO": "অ্যাঙ্গোলা",
  "VN": "ভিয়েতনাম",
  "GN": "গিনি",
  "MW": "মালাউই",
  "BY": "বেলারুশ",
  "IM": "আইল অফ ম্যান",
  "BI": "বুরুন্ডি",
  "BS": "বাহামা দ্বীপপুঞ্জ",
  "CK": "কুক দ্বীপপুঞ্জ",
  "MH": "মার্শাল দ্বীপপুঞ্জ",
  "CR": "কোস্টারিকা",
  "HK": "হংকং সার চীন",
  "AD": "এ্যান্ডোরা",
  "BN": "ব্রুনাই",
  "SN": "সেনেগাল",
  "AE": "আরব যুক্তরাষ্ট্র",
  "GI": "জিব্রাল্টার",
  "CA": "কানাডা",
  "AX": "অল্যান্ড দ্বীপপুঞ্জ",
  "UY": "উরুগোয়ে",
  "WF": "ওয়ালিস এবং ফুটুনা",
  "GM": "গাম্বিয়া",
  "SO": "সোমালিয়া",
  "RU": "রাশিয়া",
  "PL": "পোল্যান্ড",
  "FM": "মাইক্রোনেশিয়া",
  "ET": "ইথিওপিয়া",
  "EE": "এস্তোনিয়া",
  "SK": "স্লোভাকিয়া",
  "AS": "আমেরিকান সামোয়া",
  "ZM": "জাম্বিয়া",
  "AL": "আলবেনিয়া",
  "AT": "অস্ট্রিয়া",
  "VA": "ভ্যাটিকান",
  "TW": "তাইওয়ান, চীন",
  "BD": "বাংলাদেশ",
  "AR": "আর্জেন্টিনা",
  "EH": "পশ্চিম সাহারা",
  "MO": "ম্যাকাও চীনা একক শাসন অঞ্চল",
  "MV": "মালদ্বীপ",
  "GU": "গুয়াম",
  "AW": "আরুবা",
  "AI": "এ্যাঙ্গুইলা",
  "CL": "চিলি",
  "IL": "ইসরায়েল",
  "GD": "গ্রেনাডা",
  "WS": "সামোয়া",
  "SE": "সুইডেন",
  "GP": "গুয়াদেলৌপ",
  "YE": "ইমেন",
  "GT": "গোয়ামালা",
  "BG": "বুলগেরিয়া",
  "SJ": "স্বালবার্ড ও জান মায়না",
  "CO": "কলম্বিয়া",
  "LS": "লেসোথো",
  "LV": "ল্যাটভিয়া",
  "UM": "মার্কিন বাহিরজমীন টারিটরি",
  "MX": "মেক্সিকো",
  "DO": "ডোমিনিকান প্রজাতন্ত্র",
  "PE": "পেরু",
  "HN": "হন্ডুরাস",
  "TC": "টার্কস ও কেইকস দ্বীপপুঞ্জ",
  "VI": "উপজাতি ভার্জিন দ্বীপপুঞ্জ, মার্কিন যুক্তরাষ্ট্রের",
  "FJ": "ফিজি",
  "MP": "উত্তর মারিয়ানা দ্বীপপুঞ্জ",
  "AC": "অ্যাসেনশন দ্বীপ",
  "NA": "নামিবিয়া",
  "SZ": "সোয়াজিল্যান্ড",
  "RW": "রুয়ান্ডা",
  "BH": "বাহরাইন",
  "KN": "সেন্ট কিটস এবং নেভিস",
  "TN": "তিউনিস",
  "AF": "আফগানিস্তান",
  "VG": "ভার্জিন দ্বীপপুঞ্জ, ইংরেজী",
  "KE": "কেনিয়া",
  "PK": "পাকিস্তান",
  "GL": "গ্রীনল্যান্ড",
  "SY": "সিরিয়া",
  "CU": "কিউবা",
  "RS": "সার্বীয়া",
  "BF": "বুরকিনা ফাসো",
  "BM": "বারমুডা",
  "BZ": "বেলিজ",
  "SV": "এল সালভেদর",
  "CN": "চীন",
  "MF": "সেন্ট মার্টিন",
  "NF": "নরফোক",
  "MZ": "মোজাম্বিক",
  "LU": "লাক্সেমবার্গ",
  "TO": "টোঙ্গা",
  "GR": "গ্রীস",
  "SI": "স্লোভানিয়া",
  "PW": "পালাউ দ্বীপপুঞ্জ",
  "TZ": "তাঞ্জানিয়া",
  "IR": "ইরান",
  "GG": "গুএর্নসি দ্বীপপুঞ্জ",
  "SM": "সান মারিনো",
  "TF": "দক্ষিণ ফরাসি সীমান্তস্থ জমি",
  "PS": "প্যালেস্টাইন",
  "SC": "সিসিলি",
  "BT": "ভুটান",
  "JM": "জামাইকা",
  "BR": "ব্রাজিল",
  "CH": "সুইজারল্যান্ড",
  "SH": "সেন্ট হেলেনা",
  "HU": "হাঙ্গেরি",
  "TM": "তুর্কমেনিস্তান",
  "LT": "লিথুয়ানিয়া",
  "MC": "মোনাকো",
  "LI": "লিখটেনস্টাইন",
  "LR": "লাইবেরিয়া",
  "GE": "জর্জিয়া",
  "SA": "সৌদি আরব",
  "GB": "যুক্তরাজ্য",
  "VE": "ভেনেজুয়েলা",
  "MU": "মরিশাস",
  "HR": "ক্রোয়েশিয়া",
  "SR": "সুরিনাম",
  "CM": "ক্যামেরুন",
  "IQ": "ইরাক",
  "BO": "বলিভিয়া",
  "MN": "মঙ্গোলিয়া",
  "DZ": "আলজেরিয়া",
  "TK": "টোকেলাউ",
  "MG": "মাদাগাস্কার",
  "YT": "মায়োত্তে",
  "CC": "কোকোস (কিলিং) দ্বীপপুঞ্জ",
  "LA": "লাওস",
  "PT": "পর্তুগাল",
  "QA": "কাতার",
  "AN": "নেদারল্যান্ডস এ্যান্টিলিস",
  "PN": "পিটকেয়ের্ন দ্বীপ",
  "ES": "স্পেন",
  "VC": "সেন্ট ভিনসেন্ট এবং গ্রেনাডাইনস",
  "AU": "অস্ট্রেলিয়া",
  "CX": "ক্রিসমাস দ্বীপ",
  "KM": "কমোরোস",
  "MR": "মৌরিতানিয়া",
  "FR": "ফ্রান্স",
  "SG": "সিঙ্গাপুর",
  "BV": "বুভে দ্বীপ",
  "PH": "ফিলিপাইন",
  "CY": "সাইপ্রাস",
  "TV": "টুভালু",
  "CF": "মধ্য আফ্রিকার প্রজাতন্ত্র",
  "EC": "ইকুয়েডর",
  "GW": "গিনি-বিসাউ",
  "IE": "আয়ারল্যান্ড",
  "LK": "শ্রীলঙ্কা",
  "ER": "ইরিত্রিয়া",
  "GQ": "নিরক্ষীয় গিনি",
  "NP": "নেপাল",
  "BE": "বেলজিয়াম",
  "GY": "গায়ানা",
  "DK": "ডেনমার্ক",
  "MQ": "মার্টিনিক",
  "UZ": "উজবেকিস্তান",
  "CI": "কোট ডিভোয়ার",
  "ID": "ইন্দোনেশিয়া",
  "BJ": "বেনিন",
  "ST": "সাওটোম্যাক ও প্রিন্সিপি",
  "KH": "কাম্বোজ",
  "KZ": "কাজাখস্থান",
  "MS": "মন্টসেরাট",
  "TH": "থাইল্যান্ড",
  "FI": "ফিনল্যান্ড",
  "ML": "মালি",
  "AM": "আর্মেনিয়া",
  "IT": "ইতালি",
  "NR": "নাউরু",
  "PG": "পাপুয়া নিউ গিনি",
  "ZW": "জিম্বাবুয়ে",
  "JO": "জর্ডন",
  "OM": "ওমান",
  "ME": "মন্টেনেগ্রো",
  "JE": "জার্সি",
  "NZ": "নিউজিল্যান্ড",
  "VU": "ভানুয়াতু",
  "DE": "জার্মানি",
  "CZ": "চেক প্রজাতন্ত্র",
  "DM": "ডোমিনিকা",
  "KY": "কেম্যান দ্বীপপুঞ্জ",
  "BW": "বটসোয়ানা",
  "RO": "রোমানিয়া",
  "PR": "পুয়ের্তো রিকো",
  "AZ": "আজারবাইজান",
  "IO": "আংগুলার ভারতসাগর অঞ্চল",
  "UA": "ইউক্রেন",
  "TG": "টোগো",
  "MY": "মালয়েশিয়া",
  "AG": "অ্যান্টিগুয়া ও বার্বুডা",
  "EG": "মিশর",
  "GS": "দক্ষিণ জর্জিয়া ও দক্ষিণ স্যান্ডউইচ দ্বীপপুঞ্জ",
  "MM": "মায়ানমার",
  "BB": "বার্বাডোস দ্বীপপুঞ্জ",
  "KI": "কিরিবাতি",
  "All_Country": "সমস্ত",
  "post_state_country": "পরিবহন খরচ: {country} {state} {postFee} ",
  "zhichiDeliveryCountry": "বান্দরগাহে প্রেরণ",
  "ShippingFee": "পাঠানো খরচ",
  "reviewOutOf": "{rating} তারা, মোট 5 তারা",
  "product.pifa.label": "কিনুন {startnum} - {endnum} কিট",
  "product.pifa.type.1": "ছাড়",
  "Write_a_review": "একটি পর্যালোচনা লিখুন",
  "BasedOnTotalReviews": "মোট {total} টি পর্যালোচনার উপর ভিত্তি করে",
  "product.wholesale": "থোক মূল্য",
  "reviewMostRecent": "সবচেয়ে সাম্প্রতিক পর্যালোচনা",
  "product.pifa.type.2": "একক মূল্য",
  "product.num.danwei": "পিস.",
  "good.shoppingDateLabel": "পাঠানোর সময়",
  "good.shippingPeriod": "দিনের মধ্যে প্রেরণ",
  "emailError": "ইমেইল ফরম্যাট ভুল",
  "addressNote": "মন্তব্য",
  "Concactus": "যোগাযোগ",
  "addressMessage": "আপনার ঠিকানাটি সঠিক এবং ত্রুটি নেই এমন হওয়া নিশ্চিত করুন। চেকআউট পরে আমরা ঠিকানা পরিবর্তন করতে পারি না।",
  "showOrderSummary": "অর্ডার সারাংশ",
  "payment_method": "পেমেন্ট পদ্ধতি",
  "emailNotNullError": "ইমেল দিয়ে পূর্ণ করা আবশ্যক",
  "orderCreateLoading": "অর্ডার তৈরি হচ্ছে ...",
  "emailNote": "যোগাযোগ",
  "emailMessage": "আপনার ইমেল ঠিকানাটি সঠিক এবং ত্রুটি নেই তা নিশ্চিত করুন। আমরা আপনাকে আমাদের অর্ডার নিশ্চয়তা ইমেল পাঠাব।",
  "payment_method_message": "সমস্ত লেনদেন নিরাপদ এবং এনক্রিপ্টেড।",
  "go_buy_goods": "কেনাকাটা চালিয়ে যান",
  "tap_cancel_order": "অর্ডার বাতিল করতে এখানে ক্লিক করুন",
  "order_review": "অর্ডার পর্যালোচনা",
  "Add_new_address": "একটি নতুন ঠিকানা যুক্ত করুন",
  "promo_code_type_3": "পুরো হওয়া সমস্ত বিজয় কুপন",
  "IdCardNotNull": "দয়া করে আপনার নামটি লিখুন",
  "UploadVideo": "ভিডিও আপলোড করুন",
  "video": "ভিডিও",
  "UploadImage": "ছবি আপলোড করুন",
  "uploadImageing": "আপলোড চলছে ...",
  "BillingInfoNotNull": "বিলিং তথ্য অপূর্ণ",
  "promo_code_type_2": "ভাউচার",
  "UploadError": "আপলোড ব্যর্থ হয়েছে",
  "promo_code_type_4": "হার-যান্ত্রিক কুপন মেরুদন্ড",
  "image": "চিত্র",
  "paymentMethodNotNull": "দয়া করে পেমেন্ট পদ্ধতি নির্বাচন করুন",
  "promo_code_type_1": "ডিসকাউন্ট কুপন",
  "shippingInfoNotNull": "শিপিং তথ্য অপূর্ণ",
  "reviewDetail": "মূল্যায়ন বিশদ",
  "DeliveryCountry": "বিতরণ অঞ্চল",
  "prompt_error": "উপদেশ ভুল",
  "save_review_success": "তালিকা সফলভাবে রচনা করা হয়েছে",
  "ORDER_COMPLETED": "সম্পন্ন হয়েছে",
  "crate_after_sales": "বিক্রয় পরে তাকে ক্রিয়েট করা হয়েছে",
  "Thank_You_Order": "আপনার অর্ডারের জন্য ধন্যবাদ!",
  "Thank_You_Order_sub": "আমরা শীঘ্রই আপনার অর্ডারটি প্রক্রিয়াধীন করব এবং আপনি অর্ডার প্রক্রিয়াকরণ সম্পর্কে একটি ইমেল পাবেন।",
  "BootomCookieContext": "এই সাইটটি কুকিজ ব্যবহার করে সাইটটি স্বাভাবিকভাবে কাজ করতে সহায়তা করে এবং আমরা কিভাবে এটি সাথে সম্পর্ক রাখি তা জানতে সাহায্য করে। আমরা এই কুকিগুলি ব্যবহার করে আপনাকে আরও ভাল ব্যক্তিগতভাবে একজন ব্যবহারকারী তৈরি করতে চাই। যদি আপনি এই ওয়েবসাইটটি ব্যবহার করত",
  "order_reivice_message": "আপনি কি পণ্য গ্রহণ করেছেন তা নিশ্চিত করতে চান?",
  "order_reivice_btn": "গৃহীত করুন",
  "order_reivice_label": "অর্ডার গ্রহণ",
  "order_reivice_success": "গৃহীত করার জন্য ধন্যবাদ",
  "collpase_show": "আরও দেখুন",
  "collpase_hide": "বন্ধ করুন",
  "CouponCode": "ডিসকাউন্ট কোড",
  "wechatPayScannerCode": "বারকোড স্ক্যান করার জন্য দয়া করে ওয়েচ্যাট ব্যবহার করুন",
  "processing": "পরিষেবা পরবর্তী প্রক্রিয়াধীন",
  "finished": "পরিষেবা সম্পন্ন হয়েছে",
  "login.showPrice": "লॉग ইন করার পর দাম দেখুন",
  "After_Sales_Unknown": "পরিষেবা অবস্থান অজানা",
  "order_payment_list_null": "প্রক্রিয়াধীন কোনো অর্ডার নেই",
  "Cancel": "বাতিল করুন",
  "thankyou_concat": "যদি কোনো প্রশ্ন থাকে তাহলে আমাদের সাথে যোগাযোগ করুন"
}